import React, { ReactNode, useContext, useEffect}  from "react"
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Alert, Button, Col, Descriptions, Divider, Form, Input, List, Result, Row } from 'antd';
import { Flex, Typography } from "antd";

import { EnumTipoDeDocumento } from "../../../../../../Models/Domain/Pessoa/Enum";
import { Formatacoes } from "../../../../../../Utils/Formatacao";
import { TypeAluno } from "../../../../../../Models/Domain/Pessoa/Aluno";
import { TypeResponsavel } from "../../../../../../Models/Domain/Pessoa/Responsavel";

import Utilitario from "../../../../../../Utils/Utilitario";
import { AlunoSelect } from "../../../../Manager/Pessoa/Aluno/AlunoSelect";
import { TypeInscricaoDoAlunoNaViagem } from "../../../../../../Models/Domain/Viagem/InscricaoDoAlunoNaViagem";
import { SessaoARContext } from "../../../../../Contexts/SessaoContext";
import TelaPermissao from "../../../../../../Components/Base/Permissao/TelaPermissao";
import { useInscreverNovoAluno } from "../../../../../../Services/Domain/Viagem/InscricaoService";
import { ContextInscricao } from "../InscricaoDaViagem";
import { useListarAlunoDoResponsavel } from "../../../../../../Services/Pessoa/AlunoResponsavelServices";
import { extractorNomePessoa } from "@/Models/Pessoa/Pessoa";

const {enumParaString: str, capitalizarInicial} = Utilitario;

export type ValidacaoDosDadosBasicos = {
    onde: "aluno" | "responsavel",
    campo: string,
    mensagem?: string,
}

export interface IDadosBasicosProps {
    // responsavel: TypeResponsavel,
    // aluno: TypeAluno,

    // hrefAlterarResponsavel?: string,
    // hrefAlterarAluno?: string,

    // validacaoAPI: [ValidacaoDosDadosBasicos[], React.Dispatch<React.SetStateAction<ValidacaoDosDadosBasicos[]>>];
    senhaViagem?:string;
    onSucesso?:(inscricao:TypeInscricaoDoAlunoNaViagem) => void;
    onCancelar?:() => void;
    elementoSalvar?:ReactNode;
    textoSalvar?:ReactNode;
    elementoCancelar?:ReactNode;
    textoCancelar?:ReactNode;
}

type FormType = {
    inscricao:TypeInscricaoDoAlunoNaViagem;
}
export const DadosBasicos: React.FC<IDadosBasicosProps> = ({
    onSucesso,
    onCancelar,
    elementoSalvar,
    textoSalvar,
    elementoCancelar,
    textoCancelar,
    senhaViagem,
    ...props
}) => {
    const sessao = useContext(SessaoARContext);
    const responsavel = sessao?.sessao?.info as TypeResponsavel;
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const senhaComoParametro = params.get("s");
    const senha = senhaViagem ?? senhaComoParametro ?? "";
    const contextInscricao = useContext(ContextInscricao);
    const [formulario] = Form.useForm<FormType>();
    const aluno = Form.useWatch(["inscricao", "aluno"], formulario);

    const { inscricao, setInscricao } = contextInscricao;

    const { mutate, isPending } = useInscreverNovoAluno({
        onSuccess(response, variables, context) {
            const data = response.data;
            setInscricao((prev) => {
                return {
                    ...prev,
                    aluno : {
                        ...(prev.aluno ?? {}),
                        codigo : data.codAluno
                    }
                } as TypeInscricaoDoAlunoNaViagem;
            });
            onSucesso?.(data);
        },
        onError(error, variables, context) {
            if ((error.response as any)?.data?.data?.statusCodeInterno == "pessoa-bloqueio")
            {
                navigate("/status-bloqueado");
            }
        },
    });

    const { data: dataAlunosResponsaveis, isSuccess: isSucessAlunoResponsavel } = useListarAlunoDoResponsavel({});
    
    function salvar(formData: FormType) {
        formData.inscricao.viagem = {
            senha: senha,
        } as any;

        mutate(formData.inscricao);
    }
    function cancelar() {
        onCancelar?.();
    }

    useEffect(() => {
        if (isSucessAlunoResponsavel) {
            formulario.setFieldsValue({
                inscricao: {
                    viagem: {
                        senha: senha,
                    },
                    aluno: dataAlunosResponsaveis.find((f) => f.aluno.codigo == inscricao.aluno?.codigo)?.aluno ?? { codigo: 0 },
                },
            });
        }
    }, [isSucessAlunoResponsavel, inscricao.aluno?.codigo, senha]);

    const isLoading = isPending;

    if (senha.length <= 0)
        return (
            <Result
                status="403"
                title="Não autorizado"
                subTitle="Desculpe, não foi possível identificar a senha da viagem que deseja se inscrever!"
                extra={
                    <Button type="primary" onClick={() => navigate(-1)}>
                        Voltar
                    </Button>
                }
            />
        );

    return (
        <Form<FormType> form={formulario} layout="vertical" autoComplete="off" onFinish={salvar}>
            <Row gutter={16} wrap>
                <Form.Item<FormType> name={["inscricao", "viagem", "senha"]} hidden rules={[{ required: true }]}>
                    <Input hidden={true} />
                </Form.Item>

                <Col xs={24}>
                    <Form.Item<FormType>
                        name={["inscricao", "aluno"]}
                        rules={[
                            {
                                required: true,
                                message: "Por favor, selecione um aluno",
                            },
                        ]}
                    >
                        <AlunoSelect permiteAlterarAluno={false} permiteCadastrarNovoAluno={(inscricao.codigo ?? 0) === 0} disabled={(inscricao.aluno?.codigo ?? 0) > 0} />
                    </Form.Item>
                </Col>

                {inscricao.viagem?.observacoes && (
                    <Col xs={24}>
                        <Typography>
                            <Typography.Text>{inscricao.viagem.observacoes}</Typography.Text>
                        </Typography>
                    </Col>
                )}

                {aluno !== null && aluno !== undefined && ((aluno.codigo ?? 0) === -1 || (aluno.codigo ?? 0) > 0) && (
                    <Col xs={24}>
                        <Divider orientation="left" style={{ marginTop: 0 }}>
                            Aluno
                        </Divider>
                        <Descriptions column={{ xs: 1, sm: 2, md: 2, lg: 4, xl: 4, xxl: 4 }} layout="horizontal">
                            <Descriptions.Item label="Nome">{extractorNomePessoa(aluno.pessoa ?? {}) ?? "N/A"}</Descriptions.Item>

                            <Descriptions.Item label="Data de Nascimento">
                                {aluno.dataDeNascimento ? Formatacoes.paraData(aluno.dataDeNascimento)?.toLocaleDateString() : "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Gênero">{aluno?.pessoa?.generoExibicao ?? "N/A"}</Descriptions.Item>

                            <Descriptions.Item label={aluno?.pessoa?.cpf ? "CPF" : (aluno?.pessoa?.passaporte ? "Passaporte" : "RNE")}>
                                {aluno?.pessoa?.cpf ?? (aluno?.pessoa?.passaporte ?? aluno?.pessoa?.rne)}
                            </Descriptions.Item>
                        </Descriptions>
                    </Col>
                )}
                <Col xs={24}>
                    <Divider orientation="left">Responsável</Divider>
                    <Descriptions layout="horizontal">
                        <Descriptions.Item label="Nome">{responsavel.pessoa?.nome ?? "N/A"}</Descriptions.Item>

                        <Descriptions.Item label={str(EnumTipoDeDocumento, responsavel.tipoDeDocumento) ?? "Documento"}>
                            {responsavel.documento ?? "N/A"}
                        </Descriptions.Item>

                        <Descriptions.Item label="Data de Expedição">
                            {responsavel.dataDeExpedicaoDoDocumento
                                ? Formatacoes.paraData(responsavel.dataDeExpedicaoDoDocumento)?.toLocaleDateString()
                                : "N/A"}
                        </Descriptions.Item>

                        <Descriptions.Item label="Telefone">
                            {((): string => {
                                const telefone = responsavel.pessoa?.telefones?.find((t) => t.principal == true) ?? responsavel.pessoa?.telefones?.at(0);
                                if (telefone == undefined) return "N/A";

                                return `(${telefone.ddd}) ${telefone.numero}`;
                            })()}
                        </Descriptions.Item>

                        <Descriptions.Item label="E-mail">
                            {((): string => {
                                const email = responsavel.pessoa?.emails?.find((e) => e.principal == true) ?? responsavel.pessoa?.emails?.at(0);
                                if (email == undefined) return "N/A";

                                return `${email.endereco}`;
                            })()}
                        </Descriptions.Item>

                        {/* <Descriptions.Item label="Endereço">
                            {((): string => {
                                return responsavel.pessoa?.enderecos?.at(0) ? Formatacoes.formatarEndereco(responsavel.pessoa.enderecos.at(0)!) : "N/A";
                            })()}
                        </Descriptions.Item> */}
                    </Descriptions>
                </Col>
                <Col xs={24}>
                    <Divider />
                    <Flex justify="start" gap={8}>
                        <Button type="primary" danger htmlType="reset" onClick={cancelar}>
                            {textoCancelar ?? "Cancelar"}
                        </Button>
                        <Button loading={isLoading} type="primary" htmlType="submit">
                            {textoSalvar ?? "Salvar"}
                        </Button>
                    </Flex>
                </Col>
            </Row>
        </Form>
    );

    // return <div>
    // <Flex vertical gap={16}>
    {
        /*             
            <Divider orientation="left" style={{margin: 0}}>
                <Typography.Title style={{ margin: 0 }} level={4}> Confirme os dados a seguir</Typography.Title>
            </Divider> */
    }

    {
        /* <Divider orientation="left" style={{margin: 0}}>Aluno</Divider>
            <Form<FormType>
                component={"div"}
                layout='vertical' 
                autoComplete='off'
                onFinish={salvar}
            >
                <Row gutter={16} wrap>
                    <Form.Item name={[""]}>
                        <AlunoSelect 
                            permiteAlterarAluno={false}
                            permiteCadastrarNovoAluno={true}
                            label={null}
                        />
                    </Form.Item>
                </Row>
            </Form> */
    }

    {
        /* <Descriptions bordered layout="vertical">
                <Descriptions.Item label="Nome">
                    {aluno.pessoa?.nome ?? "N/A"}
                </Descriptions.Item>

                <Descriptions.Item label="Data de Nascimento">
                    {aluno.dataDeNascimento ? Formatacoes.paraData(aluno.dataDeNascimento)?.toLocaleDateString() : 'N/A'}
                </Descriptions.Item>

                <Descriptions.Item label="Gênero">
                    {aluno?.pessoa?.generoExibicao ?? 'N/A'}
                </Descriptions.Item>

                <Descriptions.Item label={str(EnumTipoDeDocumento, aluno.tipoDeDocumento) ?? "Documento"}>
                    {aluno.documento ?? 'N/A'}
                </Descriptions.Item>

                <Descriptions.Item label="Data de Expedição">
                    {aluno.dataDeExpedicaoDoDocumento ? Formatacoes.paraData(aluno.dataDeExpedicaoDoDocumento)?.toLocaleDateString() : 'N/A'}
                </Descriptions.Item>
            </Descriptions> */
    }

    {
        /* {props.hrefAlterarAluno &&
                <Col xs={24} style={{ display: "flex", flexDirection: "row-reverse" }}>
                    <Link to={props.hrefAlterarAluno}> Alterar </Link>
                </Col>
            } */
    }

    {
        /* {
                errosDeValidacaoDoAluno.length > 0 &&
                <React.Fragment>
                    <Typography>
                        <Typography.Title type="danger" level={4}> Dados inválidos ou incompletos. </Typography.Title>
                    </Typography>

                    <List
                        dataSource={errosDeValidacaoDoAluno}
                        renderItem={(v) => <Alert type="error" showIcon message={v.mensagem ?? v.campo} />} 
                    />

                    <Typography.Text type="secondary" > Verifique seus dados e consulte o suporte se necessário. </Typography.Text>
                </React.Fragment>
            } */
    }

    {
        /* <Descriptions title="Responsável" bordered layout="vertical">
                <Descriptions.Item label="Nome">
                    {responsavel.pessoa?.nome ?? 'N/A'}
                </Descriptions.Item>

                <Descriptions.Item label={str(EnumTipoDeDocumento, responsavel.tipoDeDocumento) ?? "Documento"}>
                    {responsavel.documento ?? 'N/A'}
                </Descriptions.Item>

                <Descriptions.Item label="Data de Expedição">
                    {responsavel.dataDeExpedicaoDoDocumento ? Formatacoes.paraData(responsavel.dataDeExpedicaoDoDocumento)?.toLocaleDateString() : 'N/A'}
                </Descriptions.Item>

                <Descriptions.Item label="Telefone">
                    {((): string => {
                        const telefone = responsavel.pessoa?.telefones?.find((t) => t.principal == true) ?? responsavel.pessoa?.telefones?.at(0);
                        if (telefone == undefined) return "N/A"

                        return `(${telefone.ddd}) ${telefone.numero}`
                    })()}
                </Descriptions.Item>

                <Descriptions.Item label="E-mail">
                    {((): string => {
                        const email = responsavel.pessoa?.emails?.find((e) => e.principal == true) ?? responsavel.pessoa?.emails?.at(0);
                        if (email == undefined) return "N/A"

                        return `${email.endereco}`
                    })()}

                </Descriptions.Item>

                <Descriptions.Item label="Endereço">
                    {((): string => {
                        return responsavel.pessoa?.enderecos?.at(0) ? Formatacoes.formatarEndereco(responsavel.pessoa.enderecos.at(0)!) : "N/A"
                    })()}

                </Descriptions.Item>

            </Descriptions> */
    }

    {
        /* {props.hrefAlterarResponsavel &&
                <Col xs={24} style={{ display: "flex", flexDirection: "row-reverse" }}>
                    <Link to={props.hrefAlterarResponsavel}> Alterar </Link>
                </Col>
            } */
    }

    {
        /* {
                errosDeValidacaoDoResponsavel.length > 0 &&
                <React.Fragment>
                    <Typography>
                        <Typography.Title type="danger" level={4}> Dados inválidos ou incompletos. </Typography.Title>
                    </Typography>

                    <List
                        dataSource={errosDeValidacaoDoResponsavel}
                        renderItem={(v) => <Alert type="error" showIcon message={v.mensagem ?? v.campo} />} 
                    />

                    <Typography.Text type="secondary" > Verifique seus dados e consulte o suporte se necessário. </Typography.Text>
                </React.Fragment>
            } */
    }

    {
        /* </Flex>

        <Divider />
        <Flex justify="space-between">
            <Button type="primary" danger htmlType="reset">{textoSalvar ?? "Cancelar"}</Button>
            <Button type="primary" htmlType="submit">{textoCancelar ?? }</Button>
        </Flex> */
    }
    {
        /* </div> */
    }
}
